import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 40px;
  padding: 30px;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
